import { useParams } from 'react-router-dom';

import Player from '../components/Player/Player';
import useTourVideo from '../hooks/useTourVideo/useTourVideo';

export default function Videos() {
  const { tourId, videoId } = useParams();
  const { videoUrl, subtitlesUrl, isLoading } = useTourVideo(tourId, videoId);

  if (isLoading) {
    return null;
  }

  return <Player subtitlesUrl={subtitlesUrl} videoUrl={videoUrl} />;
}
